import type { FunctionComponent } from "react";
import DashboardProfileCommonPartial from "../../../partials/common/dashboard/dashboard-profile.common.partials";

export const DashboardProfileCommonScreen: FunctionComponent = () => {
	return <DashboardProfileCommonPartial />;
};
